// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const POSTPROCESS_MODEL_RUN_STEP_SHAPES = [
  {
    stepType: PipelineStepType.POSTPROCESS_MODEL_RUN,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      modelRunInferenceOutput: {
        systemName: 'modelRunInferenceOutput',
        displayName: 'modelRunInferenceOutput',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      analysisOutputDataset: {
        systemName: 'analysisOutputDataset',
        displayName: 'Analysis output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      }
    },
    config: {
      analysisOutputStepDataId: {
        kind: 'string',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
